import classNames from "classnames";
// import Draggable from "../customDraggable";
import NoContentCard from "../noContentCard";
import styles from "./style.module.scss";

interface CustomTableProps {
  heads: Array<CustomTableHeadType>;
  title: string;
  children: any;
  isEmpty?: boolean;
  loading?: boolean;
  maxWidth?: string;
}

const CustomTable = ({
  heads,
  title,
  children,
  isEmpty,
  loading,
}: CustomTableProps) => {
  return (
    <>
      <table className="table w-full">
        <thead>
          <tr style={{ height: "48px" }}>
            {heads?.map((item: CustomTableHeadType, inx: number) => {
              return (
                <th
                  className={classNames(
                    inx === 0 ? "ps-4" : "ps-2",
                    inx === heads?.length - 1 ? "pe-4" : "pe-2",
                    styles.tableHead
                  )}
                  key={inx}
                >
                  <div
                    className={classNames(
                      "flex items-center ",
                      "justify-center"
                    )}
                  >
                    {item?.title}
                  </div>
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody className={classNames(styles.table_body)}>{children}</tbody>
      </table>
      {isEmpty && !loading ? (
        <div className={classNames("my-5")}>
          <NoContentCard
            label1="No Data Found"
            label2={`There is no data available in the "${title}" table`}
          />
        </div>
      ) : null}
    </>
  );
};

export default CustomTable;
